import { FC } from 'react'
import Layout from 'src/containers/Layout/Layout'
import PostList from 'src/containers/Post/PostList'
import { Category } from 'src/types'

const CommentPage: FC = () => {
  return (
    <Layout>
      <PostList
        queryKey="comment"
        title="名家点评"
        category={Category.Comment}
      />
    </Layout>
  )
}

export default CommentPage
